import {
  WORLD_DOTS_PATH,
  WORLD_VIEWBOX,
  CITY_POINTS,
} from "@/components/world/worldMapData";
import { arcFor } from "@/components/world/arcs";

const CONNECTIONS = [
  ["newYork", "london", 0.3],
  ["london", "dubai", 0.26],
  ["dubai", "hongKong", 0.24],
  ["sanFrancisco", "tokyo", 0.22],
  ["hongKong", "sydney", 0.28],
  ["frankfurt", "singapore", 0.2],
  ["saoPaulo", "nairobi", 0.26],
  ["mumbai", "hongKong", 0.4],
];

const NODES = [
  "hongKong",
  "singapore",
  "london",
  "newYork",
  "dubai",
  "tokyo",
  "sanFrancisco",
  "sydney",
  "frankfurt",
  "saoPaulo",
  "nairobi",
  "mumbai",
];

export const HeroWorld = () => (
  <svg
    viewBox={`0 0 ${WORLD_VIEWBOX.width} ${WORLD_VIEWBOX.height}`}
    className="h-full w-full"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient id="heroDotFade" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="hsl(var(--mist))" stopOpacity="0.55" />
        <stop offset="60%" stopColor="hsl(var(--mist))" stopOpacity="0.3" />
        <stop offset="100%" stopColor="hsl(var(--mist))" stopOpacity="0.06" />
      </linearGradient>
      <linearGradient id="heroArc" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="hsl(var(--aqua))" stopOpacity="0" />
        <stop offset="50%" stopColor="hsl(var(--aqua-bright))" stopOpacity="0.9" />
        <stop offset="100%" stopColor="hsl(var(--aqua))" stopOpacity="0" />
      </linearGradient>
    </defs>

    <g style={{ animation: "montaire-drift 42s ease-in-out infinite alternate" }}>
      <path d={WORLD_DOTS_PATH} fill="url(#heroDotFade)" />

      {CONNECTIONS.map(([a, b, lift], i) => (
        <path
          key={`${a}-${b}`}
          d={arcFor(a, b, lift)}
          fill="none"
          stroke="url(#heroArc)"
          strokeWidth="0.9"
          strokeDasharray="1000"
          style={{
            animation: `montaire-draw ${13 + i * 1.4}s linear ${i * 1.6}s infinite`,
          }}
        />
      ))}

      {NODES.map((key, i) => {
        const [x, y] = CITY_POINTS[key];
        return (
          <g key={key} transform={`translate(${x} ${y})`}>
            <circle
              r="5"
              fill="hsl(var(--aqua-bright))"
              style={{
                transformOrigin: "center",
                animation: `montaire-pulse ${6 + (i % 4)}s ease-in-out ${i * 0.5}s infinite`,
              }}
              opacity="0.35"
            />
            <circle r="1.5" fill="hsl(var(--aqua-bright))" opacity="0.85" />
          </g>
        );
      })}
    </g>
  </svg>
);
